import { Collection, Model } from 'web-mojo';
import { MachineList } from './Machine.js';

class VendingProduct extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/payments/product'
        });
    }

    nameOrId() {
        return this.get('name') || this.get('id');
    }

    priceFormatted() {
        const cents = this.get('price');
        const currency = this.get('currency') || 'USD';
        if (!cents && cents !== 0) return '—';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    }

    isInStock() {
        if (!this.get('track_inventory')) return true;
        return (this.get('quantity') || 0) > 0;
    }
}

class VendingProductList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: VendingProduct,
            endpoint: '/api/payments/product',
            ...options
        });
    }
}

VendingProduct.EDIT_FORM = {
    title: 'Edit Product',
    fields: [
        { name: 'name',             type: 'text',       label: 'Product Name',     columns: 12, required: true },
        { name: 'sku',              type: 'text',       label: 'SKU',              columns: 6 },
        { name: 'price',            type: 'number',     label: 'Price (cents)',     columns: 6 },
        { name: 'currency',         type: 'text',       label: 'Currency',          columns: 6 },
        { name: 'machine',          type: 'collection', label: 'Machine',           columns: 6,
          Collection: MachineList, labelField: 'name', valueField: 'id',
          placeholder: 'All Machines (group-wide)', requiresActiveGroup: true },
        { name: 'track_inventory',  type: 'checkbox',   label: 'Track Inventory',   columns: 6 },
        { name: 'quantity',         type: 'number',     label: 'Stock Quantity',     columns: 6 },
    ]
};

VendingProduct.ADD_FORM = {
    title: 'Add Product',
    fields: [
        { name: 'name',             type: 'text',       label: 'Product Name',     columns: 12, required: true },
        { name: 'sku',              type: 'text',       label: 'SKU',              columns: 6 },
        { name: 'price',            type: 'number',     label: 'Price (cents)',     columns: 6 },
        { name: 'currency',         type: 'text',       label: 'Currency',          columns: 6 },
        { name: 'machine',          type: 'collection', label: 'Machine',           columns: 6,
          Collection: MachineList, labelField: 'name', valueField: 'id',
          placeholder: 'All Machines (group-wide)', requiresActiveGroup: true },
        { name: 'track_inventory',  type: 'checkbox',   label: 'Track Inventory',   columns: 6 },
        { name: 'quantity',         type: 'number',     label: 'Initial Stock',      columns: 6 },
    ]
};

export { VendingProduct, VendingProductList };
